import { render, staticRenderFns } from "./FormDeveloperAboutDogNail.vue?vue&type=template&id=0722c42c&lang=pug&"
import script from "./FormDeveloperAboutDogNail.vue?vue&type=script&lang=js&"
export * from "./FormDeveloperAboutDogNail.vue?vue&type=script&lang=js&"
import style0 from "./FormDeveloperAboutDogNail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports